import * as React from 'react';
import { useMediaQuery } from '@mui/material';

import { environment } from 'environments/environment';
import { useInjection } from 'ioc';
import { Button, Container, ContainerItem, Dialog, FileContainer, Spinner } from 'ui';
import { theme } from '../../../../../../theme';
import { IdVerificationPresenter } from '../id-verification-presenter';

export const UploadIdentificationDocsModal: React.FC = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const presenter = useInjection(IdVerificationPresenter);

  const [idFront, setIdFront] = React.useState<File>();
  const [idBack, setIdBack] = React.useState<File>();
  const [idFrontRemoved, setIdFrontRemoved] = React.useState<boolean>(false);
  const [idBackRemoved, setIdBackRemoved] = React.useState<boolean>(false);

  const handleClose = () => {
    setIdFrontRemoved(false);
    setIdBackRemoved(false);
    presenter.setUploadDocumentsModalOpen(false);
  };

  const handleSave = () => {
    if (idFront || idBack) {
      presenter.updateIdentityDocs(idFront, idBack).then(() => {
        handleClose();
      });
    }
  };

  return (
    <Dialog
      isOpen={presenter.viewModel.uploadDocumentsModalOpen}
      title="Upload Identification Documents"
      handleClose={handleClose}
      action={
        <Button
          isLoading={presenter.viewModel.isSavingIdDocs}
          label="Save"
          color="primary"
          onClick={handleSave}
          disabled={
            ((!presenter.viewModel.idFrontDocument || idFrontRemoved) && !idFront) ||
            ((!presenter.viewModel.idBackDocument || idBackRemoved) && !idBack) ||
            (presenter.viewModel.idFrontDocument &&
              presenter.viewModel.idBackDocument &&
              !idFrontRemoved &&
              !idBackRemoved)
          }
          style={{ minWidth: isMobile ? '100%' : '100px' }}
          dataCy="save-ids-button"
        />
      }
    >
      {presenter.viewModel.isDeletingIdDocs ? (
        <Spinner />
      ) : (
        <Container padding="0" width="100%">
          <ContainerItem padding="0" width="100%">
            <FileContainer
              fullWidth
              existingFilesLabel="Uploaded ID Front"
              uploadFilesLabel="Upload ID Front"
              fileBucket={environment.storageConfig.userDocument}
              existingS3Files={
                presenter.viewModel.idFrontDocument ? [presenter.viewModel.idFrontDocument] : []
              }
              onRemoveExistingFile={async () => {
                setIdFrontRemoved(true);
                await presenter.deleteFrontIdDoc();
              }}
              acceptedTypes="imagesAndPdfs"
              multiple={false}
              onNewFilesChange={(file) => setIdFront(file[0])}
              dataCy="id-front"
            />
          </ContainerItem>
          <ContainerItem padding="0" width="100%">
            <FileContainer
              fullWidth
              existingFilesLabel="Uploaded ID Back"
              uploadFilesLabel="Upload ID Back"
              fileBucket={environment.storageConfig.userDocument}
              existingS3Files={presenter.viewModel.idBackDocument ? [presenter.viewModel.idBackDocument] : []}
              onRemoveExistingFile={async () => {
                setIdBackRemoved(true);
                await presenter.deleteBackIdDoc();
              }}
              acceptedTypes="imagesAndPdfs"
              multiple={false}
              onNewFilesChange={(file) => setIdBack(file[0])}
              dataCy="id-back"
            />
          </ContainerItem>
        </Container>
      )}
    </Dialog>
  );
};
